module.exports = __webpack_public_path__ + "static/media/top-bar-leaderboard-backing.9326d8ec.png";